import './App.css';
import Header from './components/Header';
import Info from './components/Info';
import Skills from './components/Skills';
import Project from './components/Project';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  const skillsData = {
    //'django'
    "Front-End": ['html', 'css', 'js', 'react'],
    "Back-End": ['php', 'spring-boot'],
    "Databases": ['sql-lite', 'sql-server', 'my-sql', 'mongodb'],
    "Programming Languages": ['cs', 'c-plus-plus', 'java', 'python'],
    "Interpreters & Shells": ['bash']
  };

  const projects = {
    "Hangman": {
        image: "/img/program/image-hangman.png",
        imageLink: "/img/link.png",
        link: "https://github.com/Soy-Nahuel/Hangman",
        view: "https://github.com/Soy-Nahuel/Hangman",
        imageView: "/img/view.png",
        technologies: ["java"]
    },
    "Google Applications Interface": {
        image: "/img/program/image-google-applications-interface.png",
        imageLink: "/img/link.png",
        link: "https://github.com/Soy-Nahuel/Google-Applications-Interface",
        view: "https://applications-interface.web.app",
        imageView: "/img/view.png",
        technologies: ["html", "css", "js"]
    },
    "Anonymous Stories":{
      image : "/img/program/image-anonymous-stories.png",
      imageLink: "/img/link.png",
      link: "https://github.com/Soy-Nahuel/Anonymous_Stories",
      view: "https://github.com/Soy-Nahuel/Anonymous_Stories",
      imageView: "/img/view.png",
      technologies: ["cs", "sql-server"]
    },
    "Paper-Rock-and-Scissors":{
      image : "/img/program/image-paper-rock-and-scissors.png",
      imageLink: "/img/link.png",
      link: "https://github.com/Soy-Nahuel/Paper-Rock-and-Scissors",
      view: "https://paper-rock-and-scissors-6058f.web.app/",
      imageView: "/img/view.png",
      technologies: ["html", "css", "js"]
    }
};

  return (
    <div className="App">
      <Header />
      <Info />
      <Skills skills={skillsData} />
      <Project projects={projects} />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;